import { Routes } from '@angular/router';
import { BootstrapRankingTabsComponent } from './bootstrap-ranking-tabs/bootstrap-ranking-tabs.component';
const ɵ0 = () => import("./../world-ranking-statistics/world-ranking/world-ranking.module.ngfactory").then(m => m.WorldRankingModuleNgFactory), ɵ1 = () => import("./../indoor-module/worldarchery_indoor-world-series-elite-ranking/indoor-world-series-elite-ranking.module.ngfactory").then(m => m.IndoorWorldSeriesEliteRankingModuleNgFactory), ɵ2 = () => import("./../world-ranking-statistics/wcup-ranking/wcup-ranking.module.ngfactory").then(m => m.WCupRankingModuleNgFactory), ɵ3 = () => import("./../world-ranking-statistics/prize-for-precision/prize-for-precision.module.ngfactory").then(m => m.PrizeForPrecisionModuleNgFactory), ɵ4 = () => import("./../world-ranking-statistics/wcup-ranking/wcup-ranking.module.ngfactory").then(m => m.WCupRankingModuleNgFactory), ɵ5 = () => import("./../world-ranking-statistics/world-ranking/world-ranking.module.ngfactory").then(m => m.WorldRankingModuleNgFactory), ɵ6 = () => import("./../world-ranking-statistics/prize-for-precision/prize-for-precision.module.ngfactory").then(m => m.PrizeForPrecisionModuleNgFactory), ɵ7 = () => import("./../continental-ranking/continental-ranking.module.ngfactory").then(m => m.ContinentalRankingModuleNgFactory);
const routes = [{
        path: '', children: [
            {
                path: 'world-ranking', loadChildren: ɵ0
            },
            {
                path: 'indoor-elite-ranking', loadChildren: ɵ1
            },
            {
                path: 'world-cup-ranking', loadChildren: ɵ2
            },
            {
                path: 'prize-precision', loadChildren: ɵ3
            },
            {
                path: "classements-coupe-du-monde",
                loadChildren: ɵ4
            },
            {
                path: "classement-mondial",
                loadChildren: ɵ5
            },
            {
                path: "prix-precision",
                loadChildren: ɵ6
            },
            {
                path: 'continental-ranking',
                loadChildren: ɵ7
            }
        ], component: BootstrapRankingTabsComponent
    }];
export class RankingTabsRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7 };
